import { Controller } from '@hotwired/stimulus'

// Clamped text with a show-more/show-less toggle. The toggle button ships
// `hidden` and is only revealed when the clamped content actually overflows.
// Callers declare the expanded CSS class via `data-text-clamp-expanded-class`;
// the collapsed label is whatever text the toggle button ships with.
export default class extends Controller {
  static targets = ['content', 'toggle']
  static classes = ['expanded']

  connect() {
    this.collapsedLabel = this.toggleTarget.textContent
    // Wait one frame so the browser has laid out the clamped content
    requestAnimationFrame(() => this.#checkOverflow())
  }

  toggle(event) {
    event.stopPropagation() // prevent card click from firing
    event.preventDefault()

    const expanded = this.contentTarget.classList.toggle(this.expandedClass)
    this.toggleTarget.textContent = expanded ? 'Show less' : this.collapsedLabel
    this.toggleTarget.setAttribute('aria-expanded', expanded)
  }

  #checkOverflow() {
    const el = this.contentTarget
    if (el.scrollHeight > el.clientHeight + 1) {
      this.toggleTarget.hidden = false
    }
  }
}
